<template lang="pug">
  DefaultLayout
    CommonSection(title="Настройки" v-if="currUser")
      FormBlock.b-notification-settings
        ._header
          h2._title Параметр
        ._items
          ._item
            ._event Онлайн чат поддержки
            ._switch
            ._switch
              BaseSwitch(:value="!accountSettings.supportChatDisabled" @change="changeSettings('supportChatDisabled', !$event)")
          ._item
            ._event Тестовый режим просмотра видео
            ._switch
            ._switch
              BaseSwitch(:value="accountSettings.movPreviewEnabled" @change="changeSettings('movPreviewEnabled', $event)")
    CommonSection(title="Настройки уведомлений" v-if="currUser")
      FormBlock.b-notification-settings
        ._header
          h2._title Настройка уведомлений
          ._sound Звуковое уведомление
            BaseSwitch(:value="!soundDisabled" @change="toggleSound()")
          ._channel(v-for="(colName, colCode) in channels") {{ colName }}
        ._items
          ._item(v-for="(rowName, rowCode) in events")
            ._event {{ rowName }}
            ._switch(v-for="(colName, colCode) in channels")
              BaseSwitch(:value="isset(rowCode, colCode)" @change="change(rowCode, colCode)")
        ._footer
          RequestIndicator(:loading="this.timeout")
          Btn(grey @click="cancel") Отмена
</template>

<script>
import modelUserCustomSettings from '@/model/userCustomSettings';

import DefaultLayout from '@/layouts/Default.vue';
import CommonSection from '@/components/CommonSection.vue';
import FormBlock from '@/components/FormBlock.vue';
import BaseSwitch from '@/components/BaseSwitch.vue';

export default {
  name: 'PersonalNotificationSettingsPage',
  components: { DefaultLayout, CommonSection, FormBlock, BaseSwitch }, // eslint-disable-line
  data() {
    return {
      val: true,
      settings: { },
      timeout: null,
    };
  },
  computed: {
    currUser() { return this.$store.state.auth.user; },
    accountSettings() { return this.currUser?.customSettings?.settings ?? {}; },
    notificationSettings() { return this.currUser?.customSettings?.notifications ?? {}; },
    soundDisabled() { return this.notificationSettings.soundDisabled === true; },
    disabledChannels() { return this.notificationSettings?.disabledChannels ?? {}; },
    channels() {
      return {
        db: 'Внутренние',
        email: 'E-mail',
      };
    },
    events() {
      return {
        'system':                     'Системные уведомления',                          // eslint-disable-line
        'become-project-member':      'Вы добавлены в проект',                          // eslint-disable-line
        'comment-publish':            'Добавление комментария',                         // eslint-disable-line
        'comment-update':             'Редактирование комментария',                     // eslint-disable-line
        'task-create-update':         'Добавление/обновление задачи',                   // eslint-disable-line
        'task-update-param':          'Обновление параметров задачи',                   // eslint-disable-line
        'task-expires_in-three-days': 'Срок задачи истекает через три дня',             // eslint-disable-line
        'task-expires_in-one-day':    'Срок задачи истекает через один день',           // eslint-disable-line
        'task-expires_in-three-hours':'Срок задачи истекает через три часа',            // eslint-disable-line
        'task-expires_now':           'Срок задачи истекает сейчас',                    // eslint-disable-line
        'task-update-author':         'Обновление автора задачи',                       // eslint-disable-line
        'task-update-manager':        'Обновление ответственного по задаче',            // eslint-disable-line
        'task-update-members':        'Обновление участников задачи',                   // eslint-disable-line
        'task-checklist-change':      'Чек-лист обновлен',                              // eslint-disable-line
        'task-checklist-check':       'Отмечен пункт чек-листа',                        // eslint-disable-line
        'contact-request-created':    'Вас хотят добавить в контакты',                  // eslint-disable-line
        'contact-request-accepted':   'Ваша заявка на добавление в контакты принята',   // eslint-disable-line
        'contact-request-declined':   'Ваша заявка на добавление в контакты отклонена', // eslint-disable-line
        'referral-sample':            'Авторские проекты',                              // eslint-disable-line
      };
    },
  },
  watch: {
    disabledChannels: {
      immediate: true,
      handler(val) {
        this.settings = { ...val };
      },
    },
  },
  methods: {
    isset(event, channel) {
      const channels = this.settings[event] || [];
      return !channels.includes(channel);
    },
    change(event, channel) {
      let channels = this.settings[event] || [];

      channels = channels.includes(channel)
        ? channels.filter((c) => c !== channel)
        : [...channels, channel];

      this.$set(this.settings, event, channels);

      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(() => {
        this.saveSettings({ ...this.notificationSettings, disabledChannels: this.settings })
          .then(() => { this.timeout = null; });
      }, 1000);
    },
    toggleSound() {
      const soundDisabled = !this.notificationSettings.soundDisabled;
      this.saveSettings({ ...this.notificationSettings, soundDisabled });
    },
    saveSettings(notifications) {
      return modelUserCustomSettings.set({ notifications });
    },
    changeSettings(key, val) {
      const settings = { ...this.accountSettings, [key]: val };
      modelUserCustomSettings.set({ settings });
    },
    cancel() {
      this.$router.push({ name: 'notifications' });
    },
  },
};
</script>

<style lang="scss">
.notification-settings {
  &__header {
    display: grid;
    grid-template-columns: 1fr 500px 80px 80px;
    justify-items: center;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #D1D9F0;
  }

  &__title {
    font-size: 18px;
    line-height: 24px;
    color: #232226;
    justify-self: start;
  }

  &__sound {
    display: flex;
    align-items: center;
    gap: 30px;
  }

  &__channel {
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.01em;
    color: var(--color-middle-gray);
  }

  &__items {
    display: flex;
    flex-direction: column;
    margin-bottom: 25px;
  }

  &__item {
    display: grid;
    grid-template-columns: 1fr 80px 80px;
    align-items: center;
    justify-items: center;

    height: 45px;
    border-radius: 8px;

    &:nth-child(even) {
      background-color: var(--main-bg);
    }
  }

  &__event {
    font-weight: bold;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.01em;
    color: var(--color-middle-gray);
    justify-self: start;
    padding-left: 25px;
  }

  &__footer {
    display: flex;
    gap: 30px;
    justify-content: flex-end;
  }

  @media (max-width: 1200px) {
    &__header {
      grid-template-columns: 1fr 80px 80px;
      row-gap: 20px;
    }

    &__title {
      grid-row: 2;
    }

    &__sound {
      grid-row: 1;
      grid-column: 1 / 3 span;
      justify-self: end;
    }
  }

  @media (max-width: 576px) {
    &__header {
      grid-template-columns: 1fr 100px 50px;
    }

    &__item {
      grid-template-columns: 1fr 50px 50px;
      height: auto;
      padding: 10px 0;
    }
  }
}
</style>
